module.exports = __webpack_public_path__ + "static/media/wallfinishes_gwp_60y_y.28ec87a9.csv";